import handleError from 'common/helpers/handleError';

export default {
  data() {
    return {
      isProviderEditing: false,
      removeId: undefined,
      provider: undefined,
      loading: {
        fetch: false,
        remove: false,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.isProviderEditing) {
      this.$refs.providerList.showLeavePageDialog();
      next(false);
    } else {
      next();
    }
  },
  computed: {
    showConfirmDialog() {
      return this.removeId !== undefined && !this.loading.fetch;
    },
    hasConnectedForms() {
      return this.provider ? this.provider.forms.length > 0 : false;
    },
    connectedFormTitles() {
      if (!this.hasConnectedForms) {
        return undefined;
      }
      return this.provider.forms.map((form) => form.title)
        .join(', ');
    },
  },
  watch: {
    removeId() {
      if (this.removeId) {
        this.fetchProvider();
      }
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      if (this.providers.length > 0) {
        return;
      }
      try {
        this.$q.loading.show();
        await this.fetchProviders();
      } catch (error) {
        handleError(error);
      } finally {
        this.$q.loading.hide();
      }
    },
    async fetchProvider() {
      try {
        this.loading.fetch = true;
        const { data } = await this.$axios.get(`${this.providerUrl}/${this.removeId}`);
        this.provider = data.data;
      } catch (error) {
        handleError(error);
      } finally {
        this.loading.fetch = false;
      }
    },
    async remove() {
      try {
        this.loading.remove = true;
        await this.removeProvider(this.removeId);
        this.onClose();
      } catch (error) {
        handleError(error);
      } finally {
        this.loading.remove = false;
      }
    },
    onClose() {
      this.removeId = undefined;
      this.provider = undefined;
    },
  },
};
